import {Component, Input, OnInit} from '@angular/core';
import {JP} from "../../helpers/jp";
import {UI_TEXTS} from "../../enums/e-texts";
import {DOCUMENT_TYPES, VALUE_TYPE} from "../../enums/enums";
import {FactoryService} from "../../services/factory.service";
import {IMarketTemplate, ISearchItem} from "../../definitions";
import {paramsHelper} from "../../helpers/params-helper";
import {SEARCH_PROP_TYPES} from "../../enums/e-search";
import {CollectionService} from "../../services/collection.service";

@Component({
  selector: 'app-nv-order-templates',
  templateUrl: './nv-order-templates.component.html',
  styles: []
})
export class NvOrderTemplatesComponent implements OnInit {

  public UI_TEXTS = UI_TEXTS
  public VALUE_TYPE = VALUE_TYPE;
  public SLOTS_COUNT_OPTIONS = [{id: 1, label:1}, {id:2, label:2}, {id:3, label:3}];

  public selected:IMarketTemplate;
  private _document: any;
  private _pointer: string;
  private _title: string;

  @Input() set document(v: any) {
    this._document = v;
  };

  @Input() set pointer(v: string) {
    this._pointer = v;
  }

  @Input() set title(v: string) {
    this._title = v;
  }

  get document() { return this._document; }
  get pointer() { return this._pointer; }
  get title() { return this._title || "no title"; }

  templateTypes:Array<ISearchItem>;

  get templates():any[]
  {
    return JP.get(this.document, this.pointer);
  }

  constructor(private factoryService:FactoryService,
              private collectionService:CollectionService) { }

  ngOnInit() {
    this.loadTemplateTypes();
  }

  onAddClick()
  {
    this.factoryService.gameObjectUtils.addMarketTemplateTo(this.document, this.pointer);
  }

  getItemLabel(template:IMarketTemplate) {
    return `${template.name}`;
  }

  onItemSelected(r:IMarketTemplate) {
    this.selected = r;
  }

  loadTemplateTypes(){
    this.templateTypes = [];

    const searchParams = paramsHelper.search()
      .addParam("_type", SEARCH_PROP_TYPES.STRING, DOCUMENT_TYPES.ORDER_TEMPLATE_TYPE)
      .json;

    const params = paramsHelper.loader()
      .setEndpointApi()
      .setAdditionalParam("filter", { id: 1, name: 1})
      .setSearchParams(searchParams);

    this.collectionService.search(params)
      .subscribe(
        r => {
          this.templateTypes = r;
          console.log(this.templateTypes);
        });
  }

}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/components/nv-order-templates/nv-order-templates.component.ts